 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"vendors~vsf-category~vsf-checkout~vsf-cms~vsf-compare~vsf-home~vsf-interective-catalogs~vsf-layout-d~7c2b1aa7","3":"vsf-category~vsf-compare~vsf-home~vsf-layout-default~vsf-my-account~vsf-not-found~vsf-product","4":"vendors~vsf-category~vsf-product~vsf-wp-categories-show~vsf-wp-posts-index~vsf-wp-posts-show","5":"vendors~vsf-checkout~vsf-layout-default","6":"SwipeActions","8":"for-download","10":"vendors~bodybuilder","11":"vendors~vsf-category","12":"vendors~vsf-checkout","13":"vendors~vsf-graphql","14":"vendors~vsf-search-panel","15":"vsf-category","16":"vsf-checkout","17":"vsf-cms","18":"vsf-compare","19":"vsf-error","20":"vsf-head-img-banners-de_main-image-json","21":"vsf-head-img-banners-de_promoted_offers-json","22":"vsf-head-img-banners-it_main-image-json","23":"vsf-head-img-banners-it_promoted_offers-json","24":"vsf-head-img-countries-json","25":"vsf-head-img-main-image-json","26":"vsf-head-img-promoted_offers-json","27":"vsf-head-img-slider-json","28":"vsf-home","29":"vsf-interective-catalogs","30":"vsf-languages-modal","31":"vsf-layout-default","32":"vsf-layout-empty","33":"vsf-layout-minimal","34":"vsf-microcart","35":"vsf-my-account","36":"vsf-not-found","37":"vsf-order-confirmation","38":"vsf-product","39":"vsf-product-gallery-carousel","40":"vsf-product-gallery-zoom-carousel","41":"vsf-reset-password","42":"vsf-search-adapter-0","43":"vsf-search-adapter-1","44":"vsf-search-panel","45":"vsf-search-panel-desktop","46":"vsf-sidebar-menu","47":"vsf-typ","48":"vsf-wishlist","49":"vsf-wp-categories-index","50":"vsf-wp-categories-show","51":"vsf-wp-posts-index","52":"vsf-wp-posts-show"}[chunkId]||chunkId) + "." + {"0":"abdfdf8ca085679d00d8","1":"325e67675ce3441bb5cc","3":"313f524c99e8755b0e53","4":"518c016425665e5ec1bd","5":"6ae4b285cf3a4d683685","6":"63524a53af5311303a4e","8":"84dd284f77a08fd054da","10":"4ab4280931d1026e0272","11":"5849de99997fbe47577d","12":"459b9e60749d1935b14b","13":"4b2bb236b5c8576d7588","14":"5dd8b9ef3aa66cd19ba8","15":"9ad6a2c2fc2d7317ddca","16":"b915356a3fe58687a719","17":"81fe601e77cb13ee43f5","18":"8888112362039aef8a34","19":"4b0b187a50f46a38d333","20":"b231f564346949181be5","21":"e0c258d0b7e551e368a2","22":"57667640fb1391f1b6a3","23":"4189bdcc51e75e775ea6","24":"5bd75da376746e10c8ff","25":"e868068d2608027d309e","26":"7d27253fb847559efa65","27":"aa4e7a04a09fa3028715","28":"98a81ed739a3aea6ca7f","29":"e7303503b20b422a3b5d","30":"e6cf18eb764b0663667e","31":"6d41e532845c98414b6a","32":"5b2c5a7154d6237649c1","33":"6567f2d01649e7d7aa1d","34":"83ae2aaabb55fdaa7dfb","35":"8d3087b4c2e307a0e7b1","36":"39ee8110d56340ab5f21","37":"65a2a5fad60218ae9a8c","38":"a7cf8ce9529536ad9d25","39":"2a3df8a9292f02ce39d7","40":"c2f35f5bdac8756e42c4","41":"43fc0e0c2d11291a0a13","42":"50098fac6b25c1775909","43":"3e1583de141070f6a13b","44":"b90a2828c416c58506df","45":"63343ce76a2af45be744","46":"fa5ae2ea73f2de215380","47":"afed2901c9674df104fb","48":"3ff02a3fd8d4d1e130c6","49":"f57b793d889a3da2403a","50":"1928ea0e2097c1042cce","51":"801d93646dc63ae18eb1","52":"7387dd675fd64e19dba4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"31": [
 				34,
 				46,
 				48
 			],
 			"34": [
 				6
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
